var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7707 4.5C29.94 4.5 32.9947 7.46793 32.9947 12.5068V12.5627H26.6427C23.6867 12.5679 21.292 14.9027 21.2867 17.7848C21.2827 20.6735 23.68 23.0187 26.6427 23.0226H33V23.4815C33 28.5204 29.9453 31.5 24.776 31.5H11.2253C6.05467 31.5 3 28.5204 3 23.4815V12.5068C3 7.46793 6.05467 4.5 11.2253 4.5H24.7707ZM18.5747 10.3124H10.1093C9.48 10.315 8.96933 10.8129 8.96666 11.4278C8.964 12.0453 9.476 12.5484 10.1093 12.551H18.5853C19.2187 12.5484 19.7307 12.0453 19.728 11.4265C19.7253 10.809 19.208 10.3098 18.5747 10.3124Z",
    fill: "url(#paint0_linear_1709_14326)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.5842 19.4875C20.0547 23.0544 21.9311 25.564 24.0733 25.4988H31.3857C32.277 25.4988 33 24.2684 33 22.7477V13.2543C32.9981 11.7368 32.277 10.5033 31.3857 10.5H23.9012C21.4644 10.5131 19.4962 13.8842 19.5 18.0385C19.5 18.5248 19.5287 19.011 19.5842 19.4875Z",
    fill: "url(#paint1_linear_1709_14326)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 19.5C26.3284 19.5 27 18.8284 27 18C27 17.1716 26.3284 16.5 25.5 16.5C24.6716 16.5 24 17.1716 24 18C24 18.8284 24.6716 19.5 25.5 19.5Z",
    fill: "url(#paint2_linear_1709_14326)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1709_14326",
    x1: 18,
    y1: 4.5,
    x2: 18,
    y2: 31.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2666FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0841C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1709_14326",
    x1: 26.25,
    y1: 10.5,
    x2: 26.25,
    y2: 25.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2666FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0841C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1709_14326",
    x1: 25.5,
    y1: 16.5,
    x2: 25.5,
    y2: 19.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2666FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0841C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.a6f75ecd005c8b7af65c1e0914886999.svg";
export { ForwardRef as ReactComponent };